import { Constants } from "utilities/constants";

export const IsSubmitted = (uwStatus) => uwStatus === Constants.UnderwriteStatus.SUBMITTEDPRICING 

export const CheckTaskCompleted = (task, showPostAcquisitions) => {
  const { underwriteStatus, isPostAcquisitionUnderwrite, valuationsPostAcquisitionCount } = task;
  if (showPostAcquisitions) {
    return isPostAcquisitionUnderwrite && valuationsPostAcquisitionCount > 0;
  }
  return (
    underwriteStatus === Constants.UnderwriteStatus.SAVEDPRICING ||
    underwriteStatus === Constants.UnderwriteStatus.SAVEDNOBID ||
    underwriteStatus === Constants.UnderwriteStatus.SUBMITTEDPRICING ||
    underwriteStatus === Constants.UnderwriteStatus.SUBMITTEDNOBID ||
    underwriteStatus === Constants.UnderwriteStatus.SUBMISSIONPENDING ||
    underwriteStatus === Constants.UnderwriteStatus.SUBMISSIONFAILED
  );
}

export const PostAcqCheckTaskCompleted = (task) => {
  return [Constants.PostAcqUnderwriteStatus.SAVED, Constants.PostAcqUnderwriteStatus.SUBMITTED].includes(task.underwriteStatus);
}